import { render, staticRenderFns } from "./YMultitags.vue?vue&type=template&id=03a12c60"
import script from "./YMultitags.vue?vue&type=script&lang=js"
export * from "./YMultitags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports